import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "d-flex flex-row flex-wrap gap-1" }
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paperclip" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadedOrPlaceholder = _resolveComponent("LoadedOrPlaceholder")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (!_ctx.hidden)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("h5", null, [
          _createVNode(_component_i18n_t, { keypath: "review.review.data.commentHeading" }, {
            node: _withCtx(() => [
              _createVNode(_component_LoadedOrPlaceholder, { value: _ctx.nodeResult }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$s(_ctx.nodeResult.reviewCycleNodeName)), 1)
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.reviewCyclePhase')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.reviewer')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.realmShort')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.date')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.review')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.result')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('review.review.data.comment')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.result')), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentReferences, ([positionResult, commentReference, resultOption, commentReferenceResultOption], index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: positionResult.reviewCyclePositionResultId ?? index
                }, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, { value: commentReference }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(commentReference.reviewCycleNodeName), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, {
                      value: commentReference,
                      lines: 2
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(commentReference.positionMainOrganisationName) + " (" + _toDisplayString(commentReference.positionMainPersonGivenName) + " " + _toDisplayString(commentReference.positionMainPersonSurName) + ") ", 1),
                        (!commentReference.positionParticipantMainParticipantFlag || commentReference.positionParticipantInactiveFlag)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.$t('review.review.data.deputyWithOrganisation', {
                  surName: commentReference.positionPersonSurName,
                  givenName: commentReference.positionPersonGivenName,
                  organisation: commentReference.positionOrganisationName,
              })), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, { value: commentReference }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(commentReference.realmCode) + " " + _toDisplayString(_ctx.$s(commentReference.realmName)), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    (commentReference === _ctx.loadingPlaceholder || commentReference.reviewCyclePositionResultResultDate != null)
                      ? (_openBlock(), _createBlock(_component_LoadedOrPlaceholder, {
                          key: 0,
                          value: commentReference
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$d(new Date(commentReference.reviewCyclePositionResultResultDate * 1000), "long")), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, { value: commentReference }, {
                      default: _withCtx(() => [
                        (resultOption != null && resultOption.value === -7)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('review.review.data.notReviewed')), 1))
                          : _createCommentVNode("", true),
                        (commentReference.positionOverridingPersonId != null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('review.review.data.overridenBy', {
                  surName: commentReference.positionOverridingPersonSurName,
                  givenName: commentReference.positionOverridingPersonGivenName,
              })), 1))
                          : _createCommentVNode("", true),
                        (commentReference.reviewCyclePositionResultComment)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              innerHTML: _ctx.sanitize(commentReference.reviewCyclePositionResultComment)
                            }, null, 8, _hoisted_5))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.context.positionResultIdToAttachments.get(commentReference.reviewCyclePositionResultId), (attachment) => {
                            return (_openBlock(), _createElementBlock("a", {
                              class: "btn btn-sm btn-outline-secondary",
                              href: _ctx.getAttachmentLink(attachment),
                              target: "_blank",
                              key: attachment.id
                            }, _hoisted_9, 8, _hoisted_7))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    (commentReference === _ctx.loadingPlaceholder || (commentReference.reviewCyclePositionResultSignatureId != null && commentReferenceResultOption != null && commentReferenceResultOption.name != null))
                      ? (_openBlock(), _createBlock(_component_LoadedOrPlaceholder, {
                          key: 0,
                          value: commentReference
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass({ 'text-danger': commentReferenceResultOption.value === 0 })
                            }, _toDisplayString(_ctx.$s(commentReferenceResultOption.name)), 3)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_LoadedOrPlaceholder, { value: positionResult }, {
                      default: _withCtx(() => [
                        (positionResult.reviewCyclePositionResultComment)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              innerHTML: _ctx.sanitize(positionResult.reviewCyclePositionResultComment)
                            }, null, 8, _hoisted_10))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.context.positionResultIdToAttachments.get(positionResult.reviewCyclePositionResultId), (attachment) => {
                            return (_openBlock(), _createElementBlock("a", {
                              class: "btn btn-sm btn-outline-secondary",
                              href: _ctx.getAttachmentLink(attachment),
                              target: "_blank",
                              key: attachment.id
                            }, _hoisted_14, 8, _hoisted_12))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value"])
                  ]),
                  _createElementVNode("td", null, [
                    (positionResult === _ctx.loadingPlaceholder || positionResult.reviewCycleCommentOptionName != null)
                      ? (_openBlock(), _createBlock(_component_LoadedOrPlaceholder, {
                          key: 0,
                          value: positionResult
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass({ 'text-danger': positionResult.reviewCycleCommentOptionValue === 0 })
                            }, _toDisplayString(_ctx.$s(positionResult.reviewCycleCommentOptionName)), 3)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ], 64))
    : _createCommentVNode("", true)
}